import { tns } from '/node_modules/tiny-slider/src/tiny-slider';

export default function tinySliderHandler() {
  const slider = document.querySelector('.js-clients-carousel');

  if (!slider) return;

  tns({
    container: slider,

    items: 1,

    slideBy: 1,

    gutter: 24,

    mouseDrag: true,

    nav: false,

    controls: true,

    loop: true,

    responsive: {
      600: {
        items: 2,
      },

      1024: {
        items: 3,
      },
    },
  });
}
